import XCard from './x-card'
import XTabs from './x-tabs'
import XTitle from './x-title'
import XStatus from './x-status'
import XUpload from './x-upload'
import AppCard from './app-card'
import ImgLoader from './img-loader'
import XCardTabs from './x-card-tabs'
import DropdownMenu from './dropdown-menu'
import GroupSelect from './group-select'
import ComponentNameInput from './component-name-input'


/* eslint-disable */
export default {
    install(Vue) {
        Vue.component(XCard.name, XCard)
        Vue.component(XTabs.name, XTabs)
        Vue.component(XTitle.name, XTitle)
        Vue.component(XStatus.name, XStatus)
        Vue.component(AppCard.name, AppCard)
        Vue.component(XUpload.name, XUpload)
        Vue.component(ImgLoader.name, ImgLoader)
        Vue.component(XCardTabs.name, XCardTabs)
        Vue.component(DropdownMenu.name, DropdownMenu)
        Vue.component(GroupSelect.name, GroupSelect)
        Vue.component(ComponentNameInput.name, ComponentNameInput)
    }
}
